
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pacotes/[destino]",
      function () {
        return require("private-next-pages/pacotes/[destino]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pacotes/[destino]"])
      });
    }
  